import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderChoices from "./useReorderChoices";
import { txt } from "../../../services/translation";

export default function useDeleteChoice(){

    const {quizId} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', quizId, 'choices'], [quizId]);

    const reorderChoices = useReorderChoices()

    return (id) => {

        const ok = window.confirm(txt('confirmDeleteChoice'));

        if(!ok) return false;

        const oldChoices = [...queryClient.getQueryData(queryKey)];

        let newChoices = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== id);
        newChoices = reorderChoices(newChoices)
        queryClient.setQueryData(queryKey, newChoices);

        API.delete(`/design/choices/${id}`)
            .then(() => API.put('/design/choices/reorder', newChoices))
            .catch(() => {
                queryClient.setQueryData(queryKey, oldChoices)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}